<template>
  <div>
    <el-table :data="urllist" style="width: 100%" height="630">
      <el-table-column label="id">
        <template slot-scope="scope">
          <!-- <i class="el-icon-time"></i> -->
          <span style="margin-left: 10px">{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column label="交易对">
        <template slot-scope="scope">
          <div slot="reference" class="name-wrapper">
            <span>{{ scope.row.pair }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="价格">
        <template slot-scope="scope">
          <div slot="reference" class="name-wrapper">
            <span>{{ scope.row.price }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="来源交易对">
        <template slot-scope="scope">
          <div slot="reference" class="name-wrapper">
            <span>{{ scope.row.sourcePair }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="来源交易对价格">
        <template slot-scope="scope">
          <div slot="reference" class="name-wrapper">
            <span>{{ scope.row.spotPrice }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="目标价格">
        <template slot-scope="scope">
          <div slot="reference" class="name-wrapper">
            <span>{{ scope.row.targetPrice }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="数量倍数">
        <template slot-scope="scope">
          <div slot="reference" class="name-wrapper">
            <span>{{ scope.row.amount }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="开始时间">
        <template slot-scope="scope">
          <div slot="reference" class="name-wrapper">
            <span>{{ scope.row.startTime | moment }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="结束时间">
        <template slot-scope="scope">
          <div slot="reference" class="name-wrapper">
            <span>{{ scope.row.endTime | moment }}</span>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column label="状态">
        <template slot-scope="scope">

          <div slot="reference" class="name-wrapper">
            <el-switch
              active-color="#13ce66"
            
              @change="handleCodeStatusChange(scope.row, $event)"
              :value="scope.row.controlStatus ? true : false"
            ></el-switch>
          </div>
        </template>
      </el-table-column> -->

      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="primary"
            circle
            icon="el-icon-edit"
            @click="handleEdit(scope.$index, scope.row)"
          ></el-button>
          <!-- <el-button
            size="small"
            type="danger"
            circle
            icon="el-icon-delete"
            @click="handleDelete(scope.$index, scope.row)"
          ></el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      :title="`修改${ruleForm.pair}配置`"
      width="600px"
      :visible.sync="dialogVisibleChange"
      @close="closeDialog"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="来源交易对价格" prop="spotPrice">
          <el-input
            type="number"
            v-model="ruleForm.spotPrice"
           disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="目标价格" prop="targetPrice">
          <el-input
            type="number"
            v-model="ruleForm.targetPrice"
            placeholder="请输入目标价格"
          ></el-input>
        </el-form-item>
        <el-form-item label="数量倍数" prop="amount">
          <el-input
            type="number"
            v-model="ruleForm.amount"
            placeholder="请输入目标价格"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="开始时间" prop="startTime">
          <el-input
            v-model="ruleForm.startTime"
            placeholder="请选择开始时间"
          ></el-input>
        </el-form-item>
        <el-form-item label="结束时间" prop="endTime">
          <el-input
            v-model="ruleForm.endTime"
            placeholder="请选择结束时间"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="开始-结束时间" required>
          <!-- <el-input
            v-model="ruleForm.endTime"
            placeholder="请选择结束时间"
          ></el-input> -->
          <el-date-picker
            v-model="value2"
            type="datetimerange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            align="right"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label-width="300px">
          <el-button type="primary" @click="updateUrL('ruleForm')"
            >确定修改</el-button
          >
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave('currencyForm')"
          >保存</el-button
        > -->
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      dialogVisibleChange: false,
      result: true,
      ruleForm: {},
      value2: [],
      upperList: [],
      rules: {
        targetPrice: [
          {
            required: true,
            message: "请填写目标价格",
            trigger: "blur",
          },
        ],
      },
      pickerOptions: {
        shortcuts: [
        {
            text: "未来两分钟",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 600 * 200 );
              picker.$emit("pick", [start, end]);
            },
          },
        {
            text: "未来五分钟",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 600 * 500 );
              picker.$emit("pick", [start, end]);
            },
          },
        {
            text: "未来十分钟",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 600 * 1000 );
              picker.$emit("pick", [start, end]);
            },
          },
        {
            text: "未来半小时",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 600 * 1000 *3);
              picker.$emit("pick", [start, end]);
            },
          },
        {
            text: "未来一小时",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000);
              picker.$emit("pick", [start, end]);
            },
          },
        {
            text: "最近一天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.getDataList();
  },
  computed: {
    ...mapState("priceControl", ["codelist", "urllist"]),
    ...mapGetters("priceControl", ["filterList"]),
    list() {
      return this.filterList.map((item) => item.locale.toUpperCase());
    },
  },
  methods: {
    ...mapActions("priceControl", [
      "getlist",
      "delOne",
      "updateOne",
      "getUrlList",
    ]),
    async getDataList() {
      const res = await this.getUrlList({ page: 1, size: 10, pair: "" });
      // this.codelist=res.data.list
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    handleEdit(index, row) {
      this.dialogVisibleChange = true;
      this.ruleForm = {...row};
    },
    handleDelete(index, row) {
      const id = row.id;
      this.$confirm("确定要删除该链接地址吗？", "提示", {
        type: "warning",
      }).then(async () => {
        const res = await this.delOne(id);
        if (res.code == 0) {
          this.$message.success("操作成功");
          this.getDataList();
        } else {
          this.$message.error("操作失败！请重试");
        }
      });
    },

    handleCodeStatusChange(row, status) {
      const message = status
        ? "确认要开启当前Url状态吗？"
        : "确认要关当前Url？关闭该Url，相应的选项也将关闭。";

      this.$confirm(message, "提示", { type: "warning" }).then(async () => {
        if (row.status === 0) {
          row.status = 1;

          const res = await this.updateOne(row);

          if (res.data == 1) {
            this.$message.success("操作成功");
          }
        } else if (row.status === 1) {
          row.status = 0;

          const res = await this.updateOne(row);
          if (res.data == 1) {
            this.$message.success("操作成功");
          }
        }
      });
    },
    updateUrL(formName) {
      this.ruleForm = {
        ...this.ruleForm,
        startTime: new Date(this.value2[0]).getTime(),
        endTime: new Date(this.value2[1]).getTime(),
        targetPrice:Number(this.ruleForm.targetPrice),
        amount:Number(this.ruleForm.amount)
      };
      // console.log("ruleForm", this.ruleForm);
      this.$refs[formName].validate(async(valid)=>{
        if(valid){

      const res = await this.updateOne(this.ruleForm);
      if (res.code == 0) {
          this.$message.success("操作成功");
          this.dialogVisibleChange = false;
          this.getDataList();
          this.result=true
        }
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    closeDialog() {},
  },
};
</script>

<style lang="less" scoped></style>
